import {  TimePicker } from "@mui/x-date-pickers";
import { renderTimeViewClock } from '@mui/x-date-pickers/timeViewRenderers';

export default function TimePickerControl({ value, onChange, className }) {     

    const onPickerOpen = () => {
        if (!value)
            onChange(new Date());
    }

    return (
        <TimePicker
            className={className}
            label="Start Time"
            value={value}
            onChange={onChange}
            ampm={false}
            inputVariant="outlined"
            onOpen={onPickerOpen}
            slotProps={{
                popper: {
                    popperOptions: {
                        modifiers: [
                            {
                                name: 'flip',
                                options: {
                                    altBoundary: false,
                                    fallbackPlacements: ['right', 'left'],
                                },
                            },
                        ],
                    },
                }
            }}
            viewRenderers={{
                hours: renderTimeViewClock,
                minutes: renderTimeViewClock,
                seconds: renderTimeViewClock,
            }}
        />
    )
}